import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { AUTOMATION_STEP_MUTATION_SCOPE, AUTOMATION_TEMPLATE_MUTATION_KEY } from '../Automation/queryKeys';
import { invalidateAutomationTemplateQuery } from '../Automation/queries/useAutomationTemplateQuery';

export function useAutomationTemplateStepEmailOutcomeCreateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IEmailAutomationStep) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		scope: AUTOMATION_STEP_MUTATION_SCOPE,
		onSuccess: (data, variables) => {
			invalidateAutomationTemplateQuery(variables.templateId);
			onSuccess?.(data);
		},
		onError,
		mutationFn: ({
			templateId,
			stepId,
			outcome,
			step,
			impersonationContext,
		}: {
			impersonationContext?: Api.IImpersonationContext;
			templateId: string;
			stepId: string;
			outcome: Api.AutomationStepOutcome;
			step: Api.IEmailAutomationStep;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IEmailAutomationStep>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/${encodeURIComponent(
						stepId
					)}/${encodeURIComponent(outcome)}/Email`,
					impersonationContext,
				}),
				'POST',
				step
			);
		},
	});
}
